export default __webpack_public_path__ + "static/media/Logo-classify.5531b22d.png";